import type { ComponentProps } from 'react';
import { BreakpointRange, TextKey } from '@mews-distributor/common';
import type { BreakpointRangeValue } from '@mews-distributor/common';
import { useLocalizeText } from '@mews/framework';
import { OpenableVerticalProgressIndicator, ProgressIndicator, withBreakpointRange } from '@optimus-web/core';
import type { BreakpointRangeProps, ProgressIndicatorProps } from '@optimus-web/core';
import { Navbar } from '../Navbar';

// TODO delete whole component after ProgressIndicator refactoring https://mews.myjetbrains.com/youtrack/issue/RND-42409
type ProgressSteps = ProgressIndicatorProps['steps'];

interface ActiveTab {
    name: string;
}

type NavbarProps = ComponentProps<typeof Navbar>;

interface ProgressIndicatorWrapperProps extends NavbarProps, BreakpointRangeProps<BreakpointRangeValue> {
    steps: ProgressSteps;
    activeTab?: ActiveTab;
    onClick?: (value: string) => void;
}

const BaseProgressIndicatorWrapper = ({
    breakpointRange,
    steps,
    activeTab,
    onClick,
    ...other
}: ProgressIndicatorWrapperProps) => {
    const localizeText = useLocalizeText();
    if (activeTab == null) {
        return null;
    }

    const progressIndicatorProps: ProgressIndicatorProps = {
        steps,
        activeStep: activeTab.name,
        onStepChange: onClick,
    };

    return (
        <Navbar {...other} aria-label={localizeText({ textKey: TextKey.Progress })}>
            {breakpointRange === BreakpointRange.Desktop ? (
                <ProgressIndicator {...progressIndicatorProps} />
            ) : (
                <OpenableVerticalProgressIndicator {...progressIndicatorProps} />
            )}
        </Navbar>
    );
};

export const ProgressIndicatorWrapper = withBreakpointRange(BaseProgressIndicatorWrapper);
